import { useState } from "react";
import { faqs } from "@/mocks/webtoons";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-600">
            <i className="ri-question-answer-fill"></i>
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            关于韩漫推荐，你可能想问
          </h2>
          <p className="mt-4 text-sm text-foreground-600 md:text-base">
            汇总了读者最常问的几个问题，帮你更快上手选漫。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((item, idx) => {
            const open = openIndex === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-base font-bold text-foreground-950">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-transform duration-300 ${
                      open ? "rotate-45" : ""
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}